import React, { useRef, useState, createRef } from 'react';
import config from './config.json';
import { modalAddOrEditFn } from './components/addOrEdit';
import { AddOrEditForm } from './components/addOrEdits';
import { message } from 'antd';
import { SActionBtn, SLowcodeList, STableActions, SIDRender, SDrawer, SDrawerOrModal } from 'shj-components'
import { receiptWriteOffPageList, receiptWriteOffDelete, receiptWriteOffDisable, receiptWriteOffEnable, receiptWriteOffSaveOrUpdateEntity } from '@/services/fmsConfig'
export default function () {
  const listRef = useRef<any>();
  const childRef = createRef<any>()
  const [visible, setVisible] = useState<any>(false)
  const [loading, setLoading] = useState(false)
  const [editData, setEditData] = useState<any>(null)
  const [verifyTransAndArTypeListOld, setVerifyTransAndArTypeListOld] = useState<any>([])
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        let data = await receiptWriteOffPageList(current, pageSize, rest.query);
        const { records, total } = data;
        resolve({ records, total });
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const getStatusOptions = () => {
    return new Promise((resolve, reject) => {
      resolve({
        statusOptions: {
          true: '启用',
          false: '停用',
        },
      });
    });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  // 新增
  const add = (obj = {}) => {
    // const {
    //   current: { reload },
    // } = listRef;
    // modalAddOrEditFn({
    //   fn: () => {
    //     reload();
    //   },
    //   ...obj,
    // });
    setEditData(obj)
    setVisible(true)
  };
  const onEdit = (obj: object) => {
    add(obj);
  };

  const onAdd = () => {
    add();
  };

  const onLook = (obj: object) => {
    add({ ...obj, showLook: true });
  }

  const onDel = (record) => {
    receiptWriteOffDelete(record.id).then((response: any) => {
      message.success(response?.message || '删除成功');
      reloadFn();
    });
  }
  const onEnable = (record) => {
    receiptWriteOffEnable(record.id).then((response: any) => {
      message.success(response?.message || '启用成功');
      reloadFn();
    });
  }

  const onDisable = (record) => {
    receiptWriteOffDisable(record.id).then((response: any) => {
      message.success(response?.message || '禁用成功');
      reloadFn();
    });
  }

  const onCopy = (record) => {
    // 在这里添加复制逻辑
    console.log('复制', record);
    add({ ...record, showCopy: true });
  }
  const onSubmit = (value) => {
    const sequenceOptions = ['transTypeAndArType', 'posAndNegFirst', 'arRecDateAsc'];
    const nodeOptions = ['arSubmit', 'receiptConfirm'];
    sequenceOptions.forEach(option => {
      value[option] = value.sequence.includes(option) ? 1 : 0;
    });

    nodeOptions.forEach(option => {
      value[option] = value.node.includes(option) ? 1 : 0;
    });
    value.enabled = value.enabled ? true : false;
    value.verifyTransAndArTypeList = childRef.current?.getValue()
    setVerifyTransAndArTypeListOld(value.verifyTransAndArTypeList)
    delete value.sequence;
    delete value.node;
    setLoading(true)
    receiptWriteOffSaveOrUpdateEntity(value).then(res => {
      setLoading(false)
      setVisible(false)
      reloadFn()
      // onClose()
      // fn()
    }).finally(() => {
      setLoading(false)
    })
  }
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      IdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onLook(record)} copy={false}></SIDRender>
        )
      },
      statusCell(text: any) {
        return text ? '启用' : '禁用';
      },
      // 渲染操作栏
      renderOperate(text: any, record: any) {
        return (
          <div className="actionBox">
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>
                编辑
              </SActionBtn>
              {
                !record?.enabled ? <SActionBtn title="是否删除？" danger confirm
                  onClick={() => onDel(record)} okText="是" cancelText="否" >
                  删除
                </SActionBtn> : null
              }
              {/* <SActionBtn onClick={() => onLook(record)}>
                查看
              </SActionBtn> */}
              {
                record?.enabled ? (
                  <SActionBtn onClick={() => onDisable(record)}>
                    禁用
                  </SActionBtn>
                ) : (
                  <SActionBtn onClick={() => onEnable(record)}>
                    启用
                  </SActionBtn>
                )
              }
              <SActionBtn onClick={() => onCopy(record)}>
                复制
              </SActionBtn>
            </STableActions>
          </div>
        );
      },
    },
  };

  return <><SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
    <SDrawer
      title={editData?.id?'编辑':'新增'}
      width="50%"
      isHideResetBtn={false}
      open={visible}
      onClose={() => setVisible(false)}
      destroyOnClose
      onSubmit={onSubmit}
      loading={loading}
    >
      <AddOrEditForm ref={childRef} editData={editData} verifyTransAndArTypeListOld={verifyTransAndArTypeListOld} />
    </SDrawer>
  </>
}
